/**
 * @file index.tsx
 *
 * @fileoverview The page for the job selection type
 */

import { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { JobWizardStepForm } from '~/jobiqo/components/Job/Wizard/Steps/JobForm';
import { withoutAuthenticateApplicant } from '~/jobiqo/hocs/withoutAuthenticate/applicant';
import { JobWizardContextProvider } from '~/jobiqo/components/Job/Wizard/context/useJobWizardContext';

interface JobWizardJobFormProps {
  jobType: string;
}

const JobWizardJobFormPage: NextPage<JobWizardJobFormProps> = ({ jobType }) => (
  <JobWizardContextProvider>
    <JobWizardStepForm jobType={jobType} />
  </JobWizardContextProvider>
);

export const getServerSideProps: GetServerSideProps = withoutAuthenticateApplicant(
  {
    gssp: async ({ query }) => {
      let jobType = query.jobType?.toString() || 'job_per_template';

      // gracefully fallback to job per template.
      // We can't reuse the "type" from graphql because its a union not a enum.
      if (
        !['job_per_template', 'job_per_link', 'job_per_file'].includes(jobType)
      ) {
        jobType = 'job_per_template';
      }

      return {
        props: {
          jobType,
        },
      };
    },
  },
);

export default JobWizardJobFormPage;
